import { Icon } from "components/common";
import Button from "components/common/Button";
import useBottomSheet from "hooks/common/useBottomSheet";
import { useEffect, useState } from "react";
import { UserInfo } from "types/models/userInfo";

const PrimeSwipeCallEnd = () => {
    const { sheets, close } = useBottomSheet();
    const sheet = sheets.PrimeSwipeCallEnd;
    const { uid } = sheet.data;
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

    useEffect(() => {
        if (!uid) {
            return;
        }

        FriendsDataManager.getInfo(uid, (uid:string, profile:any) => {
            if (!uid) {
                return;
            }
            setUserInfo(profile);
        });
    },[uid]);

const handleSwipe = () => {
    close(sheet.id);
    FindUI.find();
};

  return <div className="flex flex-col justify-center items-center">
    <div className="typography-headline-md text-center">{brsc.sheet_swipecall_ended}</div>
    <div className="relative flex rounded-xl overflow-hidden w-[50vw] h-[50vw] my-4">
        {userInfo && <img className="w-full h-full object-cover" src={PrimeDataManager.isBJ(uid) ? 
            PhotoManager.getPrimePhotoURL(userInfo, true) : PhotoManager.getPhotoURL(userInfo, true)} alt="" />}
        {!userInfo && <div className="w-full h-full bg-base-bg-subtle" />}
        {userInfo && <div className="absolute start-0 bottom-2 flex gap-1 items-center justify-center text-center w-full">
            {<img className="flag" width="24" height="16" src={`/images/nation_flag/${userInfo.country.toLowerCase()}.svg`} alt="" />}
            {<div className="typography-headline-sm">{userInfo.nick}</div>}
        </div>}
    </div>
    <FollowButton uid={uid} />
    <Button 
        onClick={handleSwipe} 
        className="px-4 mt-5 mb-4 w-full"
        style={{ text: brsc.btn_find_new_partner, color: 'btn-bg-video-primary', borderRadius: 'full' }}
    />
  </div>;
};

const FollowButton = ({ uid }: { uid: string }) => {
    const [followed, setFollowed] = useState(false);

    useEffect(()=>{
        if (!uid) {
            return;
        }

        FriendsDataManager.isFollowing(uid, (followed:boolean) => {
            setFollowed(followed);
        });
    },[uid]);

    const handleFollow = () => {
        if (!uid) {
            return;
        }

        FriendsDataManager.setFollowing(uid, !followed);
        setFollowed(!followed);
    };

    return <div className="rounded-full px-3 py-2 bg-btn-bg-normal h-fit flex items-center gap-1 justify-center" onClick={handleFollow}>
        <Icon name={followed ? '/icons/ic_check.svg' : '/icons/ic_friend-add.svg'} size={24} color="filter-base-ic-white" />
        <div className="typography-headline-sm">{followed ? brsc.following : brsc.do_follow}</div>
    </div>;
};

export default PrimeSwipeCallEnd;